import {generateUUID} from '@di-shared/utils/uuid';
import {QrReaderResultType} from '@cci-shared/features/webviewUtils';
import {BrandType} from '@shared/cci/features/const/environment';
import {BottomSheetSelectType} from '@shared/webviewUtils';

const COMMON_INTERFACE_NAME = 'HMGCommonInterface' as const;
const ONE_APP_INTERFACE_NAME = 'HMGOneAppInterface' as const;

function makeMessage(functionName: string, request: string = '') {
  return `네이티브 래퍼 동작중입니다.\n\nscheme: ${functionName}\nrequest: ${request}`;
}

function makeResponseMessage(fieldName: string) {
  return `${fieldName}: `;
}

export default function webviewInterfaceWrapper(window: Window) {
  window[COMMON_INTERFACE_NAME] = {
    showToast(request: string = '') {
      window.alert(makeMessage('showToast', request));
    },
    openShare(request: string = '') {
      window.alert(makeMessage('openShare', request));
    },
    close(request: string = '') {
      window.alert(makeMessage('close', request));
    },
    historyBack(request: string = '') {
      window.alert(makeMessage('historyBack', request));
      window.history.back();
    },
    openNewWebView(request: any) {
      window.alert(makeMessage('openNewWebView', request));
      const parsedRequest = JSON.parse(request);
      window.open(parsedRequest.url);
    },
    openWebBrowser(request: string = '') {
      window.alert(makeMessage('openWebBrowser', request));
      const parsedRequest = JSON.parse(request);
      window.open(parsedRequest.url);
    },
    openCustomAlert(request: string = '') {
      window.alert(makeMessage('openCustomAlert', request));
      const {uid, resultFuncName, contents} = JSON.parse(request);

      let selectedIndexText = '-1';
      if (contents.buttons) {
        if (contents.buttons.length === 1) {
          selectedIndexText = '0';
        } else {
          const buttonMessage = contents.buttons.map((item: any, index: number) => `[${index}] ${item.text}`).join('\n');
          selectedIndexText = window.prompt(`어떤 버튼을 누를까?\nex. 2\n\n${buttonMessage}\n\nselectedButtonIndex: `) || '-1';
        }
      }

      window[resultFuncName](
        JSON.stringify({
          uid,
          selectedIndex: +selectedIndexText,
        })
      );
    },
    openBottomSheet(request: string = '') {
      window.alert(makeMessage('openBottomSheet', request));
      const {uid, resultFuncName, contents} = JSON.parse(request);
      let selectedIndexesText = '0';
      if (contents.items && contents.items.length > 0) {
        const itemMessage = contents.items
          .map((item: any, index: number) => `[${index}] ${item.text}${contents.selectedIndexes.includes(index) ? ' (V)' : ''}`)
          .join('\n');
        selectedIndexesText =
          window.prompt(
            `무엇을 선택할까? ${
              contents.type === BottomSheetSelectType.MULTIPLE_SELECT ? '(다중 ex. 0,2)' : '(단건 ex. 1)'
            }\n${itemMessage}\n\nselectedIndexes: `
          ) || '-1';
      }

      let selectedButtonIndexText = '-1';
      if (contents.buttons && contents.buttons.length > 0) {
        const buttonMessage = contents.buttons.map((item: any, index: number) => `[${index}] ${item.text}`).join('\n');
        selectedButtonIndexText = window.prompt(`어떤 버튼을 누를까?\nex. 2\n\n${buttonMessage}\n\nselectedButtonIndex: `) || '-1';
      }

      window[resultFuncName](
        JSON.stringify({
          uid,
          selectedIndexes: selectedIndexesText.split(',').map(Number),
          selectedButtonIndex: +selectedButtonIndexText,
        })
      );
    },
    openBottomSheetWebView(request: string = '') {
      const {readyFuncName} = JSON.parse(request);
      window[readyFuncName]('');
    },
    prepareWindowOpenPresentation(request: string = '') {
      const {readyFuncName} = JSON.parse(request);
      window[readyFuncName]('');
    },
    setBottomSheetWebViewSize(request: string = '') {
      console.log(makeMessage('setBottomSheetWebViewSize', request));
    },
    downloadUrl(request: string = '') {
      window.alert(makeMessage('downloadUrl', request));
      const {uid, resultFuncName} = JSON.parse(request);

      // 랩퍼에서는 항상 성공 반환
      window[resultFuncName](
        JSON.stringify({
          uid,
          isSuccess: true,
        })
      );
    },
    fullScreen(request: string = '') {
      console.log(makeMessage('fullScreen', request));
      const {uid, resultFuncName} = JSON.parse(request);
      window[resultFuncName](JSON.stringify({uid, topHeight: '24', bottomHeight: '34'}));
    },
  };

  window[ONE_APP_INTERFACE_NAME] = {
    getAuthToken(request: string = '') {
      window.alert(makeMessage('getAuthToken', request));
      const {uid, resultFuncName} = JSON.parse(request);
      const authToken = window.prompt(makeResponseMessage('authToken')) || '';
      window[resultFuncName](JSON.stringify({uid, authToken}));
    },
    openPinInput(request: string = '') {
      window.alert(makeMessage('openPinInput', request));
      const {uid, resultFuncName} = JSON.parse(request);
      const pin = window.prompt(makeResponseMessage('pin')) || '';
      window[resultFuncName](JSON.stringify({uid, pin}));
    },
    qrReader(request: string = '') {
      window.alert(makeMessage('qrReader', request));
      const {uid, resultFuncName} = JSON.parse(request);
      const resultTypeMap = {
        '0': QrReaderResultType.QR_PASS,
        '1': QrReaderResultType.QR_FAIL,
        '2': QrReaderResultType.DESC_BUTTON_CLICK,
        '3': QrReaderResultType.BUTTON_CLICK,
      };
      const resultType =
        // @ts-ignore
        resultTypeMap[window.prompt(`QR_PASS: 0\nQR_FAIL: 1\nDESC_BUTTON_CLICK: 2\nBUTTON_CLICK: 3\n\nresultType: `) || '0'];
      let vin = '';
      if (resultType === QrReaderResultType.QR_PASS) {
        vin = window.prompt(makeResponseMessage('vin')) || '';
      }
      window[resultFuncName](
        JSON.stringify({
          uid,
          resultType,
          result: window.btoa(window.btoa(`V:${vin}/M:asdfasdf`)),
        })
      );
    },
    vinReader(request: string = '') {
      window.alert(makeMessage('vinReader', request));
      const {uid, resultFuncName} = JSON.parse(request);
      const vin = window.prompt(makeResponseMessage('vin')) || '';
      window[resultFuncName](JSON.stringify({uid, result: vin}));
    },
    getAddressSearch(request: string = '') {
      window.alert(makeMessage('getAddressSearch', request));
      const {uid, resultFuncName} = JSON.parse(request);
      const MOCK = {
        totalCount: 3,
        contents: [
          {
            id: '1',
            title: '장소 title',
            distance: 1234,
            distanceUnit: 'km',
            address: '장소 address',
            longitude: '123.0',
            latitude: '123.0',
          },
        ],
      };
      window[resultFuncName](JSON.stringify({uid, result: MOCK}));
    },
    openNavigationExplore(request: string = '') {
      window.alert(makeMessage('openNavigationExplore', request));
    },
    openTransferPopup(request: string = '') {
      window.alert(makeMessage('openTransferPopup', request));
    },
    openExploreView(request: string = '') {
      window.alert(makeMessage('openExploreView', request));
    },
    requestLocation(request: string = '') {
      window.alert(makeMessage('requestLocation', request));
      const {uid, resultFuncName} = JSON.parse(request);
      const latitude = window.prompt(makeResponseMessage('latitude'));
      const longitude = window.prompt(makeResponseMessage('longitude'));
      window[resultFuncName](JSON.stringify({uid, latitude, longitude}));
    },
    requestChargingStatus(request: string = '') {
      window.alert(makeMessage('requestChargingStatus', request));
      const {uid, resultFuncName} = JSON.parse(request);
      const isChargingText = window.prompt(`isCharging (true:1, false:0): `) || '0';
      const remainTimeText = window.prompt(makeResponseMessage('remainTime')) || '';
      window[resultFuncName](JSON.stringify({uid, isCharging: isChargingText === '1', remainTime: +remainTimeText}));
    },
    openChargingMap(request: string = '') {
      window.alert(makeMessage('openChargingMap', request));
    },
    openMaintenanceMap(request: string = '') {
      window.alert(makeMessage('openMaintenanceMap', request));
    },
    onDateSelected(request: string = '') {
      window.alert(makeMessage('onDateSelected', request));
    },
    onDateTimeSelected(request: string = '') {
      window.alert(makeMessage('onDateTimeSelected', request));
    },
    openVehicleManagement(request: string = '') {
      window.alert(makeMessage('openVehicleManagement', request));
    },
    exit(request: string = '') {
      window.alert(makeMessage('exit', request));
      window.close();
    },
    agreeTerms(request: string = '') {
      window.alert(makeMessage('agreeTerms', request));
    },
    vehicleRefetch(request: string = '') {
      window.alert(makeMessage('vehicleRefetch', request));
    },
    openShareLocation(request: string = '') {
      window.alert(makeMessage('openShareLocation', request));
    },
    authRequest(request: string = '') {
      window.alert(makeMessage('authRequest', request));
      const {uid, resultFuncName} = JSON.parse(request);
      let isAuth = false;
      const isCanceled = window.prompt(`isCanceled (true:1, false:0): `) === '1';
      if (!isCanceled) {
        isAuth = window.prompt(`isAuth (true:1, false:0): `) === '1';
      }
      window[resultFuncName](
        JSON.stringify({
          uid,
          isAuth,
          isCanceled,
        })
      );
    },
    vehicleInitialize(request: string = '') {
      window.alert(makeMessage('vehicleInitialize', request));
      const {uid, resultFuncName} = JSON.parse(request);
      window[resultFuncName](JSON.stringify({uid, isSuccess: true}));
    },
    requestProfileManageSupport(request: string = '') {
      window.alert(makeMessage('requestProfileManageSupport', request));
      const {uid, resultFuncName} = JSON.parse(request);
      const isProfileManageSupport = window.prompt(`isProfileManageSupport (true:1, false:0): `) === '1';
      window[resultFuncName](
        JSON.stringify({
          uid,
          isProfileManageSupport,
        })
      );
    },
    getCcid(request: string = '') {
      const {uid, resultFuncName} = JSON.parse(request);
      window[resultFuncName](
        JSON.stringify({
          uid,
          ccid: `ffffffff-e087-4f64-0033-c587000000123_${import.meta.env.VITE_BRAND === BrandType.KIA ? 'UVO' : import.meta.env.VITE_BRAND === BrandType.HYUNDAI ? 'BLU' : 'GEN'}`,
        })
      );
    },
    callExternalCertification(request: string = '') {
      const {uid, externalScheme, resultFuncName} = JSON.parse(request);
      console.log(uid, resultFuncName);
      window.alert(`call ${externalScheme}`);
      window[resultFuncName](JSON.stringify({uid, isSuccess: true, errorMessage: ''}));
    },

    getVehicleServiceList(request: string = '') {
      const {uid, resultFuncName, ePrivacySupported, serviceListAllEnabled, offlineModeEnabled} = JSON.parse(request);
      console.log(uid, resultFuncName, ePrivacySupported, serviceListAllEnabled, offlineModeEnabled);
      const vehicleServiceList = {
        ePrivacySupported: true,
        serviceListAllEnabled: false,
        offlineModeEnabled: true,
      };
      window[resultFuncName](JSON.stringify({uid, vehicleServiceList}));
    },
    getCarWarningLightStatus(request: string = '') {
      /**
       * @link https://hmg.dooray.com/wiki/3621815477071999771/3885158007743147943
       */
      const {uid, resultFuncName} = JSON.parse(request);
      const status = {
        lamp: 'Invalid',
        brakeOil: 'Invalid',
        engineOil: 'Invalid',
        lowVoltageBattery: 'Invalid',
        electricVehicleBattery: 'Invalid',
        lithiumVehicleBattery: 'Invalid',
        washer: 'Invalid',
        fuel: 'Invalid',
        ureaPercent: -1,
        ecu: [
          {
            ecuId: 'ACU',
            systemName: '',
            isNormal: true,
          },
        ],
        tire: {
          frontLeft: 'Invalid',
          frontRight: 'Invalid',
          rearLeft: 'Invalid',
          rearRight: 'Invalid',
        },
      };
      console.log(uid, resultFuncName);
      window[resultFuncName](JSON.stringify({uid, status}));
    },
    getDeviceUUID(request: string = '') {
      const {uid, resultFuncName} = JSON.parse(request);
      window[resultFuncName](
        JSON.stringify({
          uid,
          deviceUUID: generateUUID(),
        })
      );
    },
  };
}

export function isWebviewInterfaceExist() {
  return (window[COMMON_INTERFACE_NAME] && window[ONE_APP_INTERFACE_NAME]) || window.webkit;
}

export function isOneAppInterfaceExist(functionName: string) {
  return (
    !!window[ONE_APP_INTERFACE_NAME]?.[functionName] || !!window.webkit?.messageHandlers?.[`${ONE_APP_INTERFACE_NAME}_${functionName}`]
  );
}
